import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import customers from './customers'
import devices from './devices'
import auth from './auth'
import tenant from './tenant'
import admin from './admin'
import users from './users'

export default new Vuex.Store({
  modules:{
    customers,
    devices,
    auth,
    tenant,
    admin,
    users
  }
})